<section class="receipt-benefit-wrapper color-gray-light">
  <div class="box-container">
    <div class="partner-topic">
      <!-- desktop heading-->
      <div
        class="partner-topic__heading partner-topic__heading--desktop color-gray"
        [innerHtml]="'RECEIPT.BENEFIT.HEADING' | translate"
      >
      </div>

      <!-- tablet heading-->
      <div
        class="partner-topic__heading partner-topic__heading--tablet color-gray"
        [innerHtml]="'RECEIPT.BENEFIT.HEADING_TABLET' | translate"
      >
      </div>

      <!-- mobile heading -->
      <div
        class="partner-topic__heading partner-topic__heading--mobile color-gray"
        [innerHtml]="'RECEIPT.BENEFIT.HEADING_MOBILE' | translate"
      >
      </div>

      <div class="partner-topic__heading-detail" [innerHtml]="'RECEIPT.BENEFIT.DETAIL' | translate"> </div>
    </div>

    <div class="box">
      <div class="box__left">
        <picture>
          <source
            srcset="https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section2-v2.webp"
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/functions/receipt/receipt-section2-v2.png"
            width="100%"
            loading="lazy"
            alt="ทำใบเสนอราคา"
            title="ทำใบเสนอราคา"
            class="box__image"
          />
        </picture>
      </div>
      <div class="box__right">
        <div class="box__item">
          <div
            class="box__item--heading color-gray custom-border"
            [innerHtml]="'RECEIPT.BENEFIT.ITEM.MESSAGE_1' | translate"
          >
          </div>
        </div>

        <div class="box__item custom-border">
          <div class="box__item--heading color-gray" [innerHtml]="'RECEIPT.BENEFIT.ITEM.MESSAGE_2' | translate"> </div>
        </div>

        <div class="box__item">
          <div
            class="box__item--heading color-gray custom-border"
            [innerHtml]="'RECEIPT.BENEFIT.ITEM.MESSAGE_3' | translate"
          >
          </div>
        </div>

        <div class="box__item">
          <div
            class="box__item--heading color-gray custom-border"
            [innerHtml]="'RECEIPT.BENEFIT.ITEM.MESSAGE_4' | translate"
          >
          </div>
        </div>

        <div class="box__item">
          <div
            class="box__item--heading color-gray custom-border"
            [innerHtml]="'RECEIPT.BENEFIT.ITEM.MESSAGE_5' | translate"
          >
          </div>
        </div>

        <div class="box__item">
          <div
            class="box__item--heading color-gray custom-border"
            [innerHtml]="'RECEIPT.BENEFIT.ITEM.MESSAGE_6' | translate"
          >
          </div>
        </div>

        <div class="box__item custom-padding">
          <div class="box__item--heading color-gray" [innerHtml]="'RECEIPT.BENEFIT.BTN' | translate"> </div>
        </div>

        <div class="box__item box__item--download-app">
          <a
            href="https://itunes.apple.com/th/app/new-flowaccount/id1454207520"
            rel="nofollow noopener"
            target="_blank"
            aria-label="Donwload IOS"
          >
            <div class="box__item--download-app--ios">
              <picture>
                <source srcset="https://flowaccountcdn.com/assets/image/_WebP/app_store.webp" type="image/webp" />
                <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/app store.png" type="image/jpeg" />
                <img
                  src="https://flowaccountcdn.com/assets/image/mobileApp/app store.png"
                  width="100%"
                  height="auto"
                  alt="flowaccount ios application"
                  title=""
                  loading="lazy"
                />
              </picture>
            </div>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.flowaccount.android&hl=th"
            rel="nofollow noopener"
            target="_blank"
            aria-label="Donwload Android"
          >
            <div class="box__item--download-app--android">
              <picture>
                <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/android3.webp" type="image/webp" />
                <source srcset="https://flowaccountcdn.com/assets/image/mobileApp/android3.png" type="image/jpeg" />
                <img
                  src="https://flowaccountcdn.com/assets/image/mobileApp/android3.png"
                  width="100%"
                  height="auto"
                  alt="flowaccount ios application"
                  title=""
                  loading="lazy"
                />
              </picture>
            </div>
          </a>

          <!-- huawei app gallery -->
          <a
            href="https://appgallery.huawei.com/app/C105848487"
            rel="nofollow noopener"
            target="_blank"
            aria-label="Donwload  huawei app gallery"
          >
            <div class="box__item--download-app--gallery">
              <picture>
                <source srcset="https://flowaccountcdn.com/new_landing/image/logo/Huawei.webp" type="image/webp" />
                <source srcset="https://flowaccountcdn.com/new_landing/image/logo/Huawei.png" type="image/png" />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/logo/Huawei.png"
                  width="100%"
                  height="auto"
                  alt="flowaccount  huawei app gallery application"
                  title=""
                  loading="lazy"
                />
              </picture>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
